import React from "react";
import axios from "axios";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import { store } from "./store";

import "./i18n";

const root = ReactDOM.createRoot(document.getElementById("root"));
const env = process.env.REACT_APP_ENV;
if (env === "PROD") {
  axios.defaults.baseURL = "https://seaportalbe.teu-eg.com/";
} else {
  axios.defaults.baseURL = "https://teu.uniparticle.com/";
}

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(//console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
